export default class TextHelp {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static async getAPI(): Promise<any> {
    if (!window['speechstream']) return Promise.reject('TextHelp not available');

    // Update Ignores
    const ignoreList = '.swal-overlay, .swal-button, qti-response-processing';
    window['speechstream'].domControlTools.getNewDomControl().addIgnoreListQuerySelector(ignoreList);

    return Promise.resolve(window['speechstream']);
  }
}
